import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useRozcestnikContext } from '@gov-nx/module/page';
import { FormSearch, FormWidthElementLayout } from '@gov-nx/ui/web';

export interface SignpostSearchProps {
	code: PageCode;
}

export const SignpostSearch = ({ code }: SignpostSearchProps) => {
	const { t } = useLocale(code);
	const { formDefinition, onSubmit } = useRozcestnikContext();

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<FormWidthElementLayout type="l">
				<FormSearch
					input={{
						field: {
							name: 'search',
							placeholder: t('vyhledat.placeholder.co-hledate'),
						},
						label: {
							children: t('vyhledat.placeholder.label'),
						},
					}}
					button={{
						'aria-label': t('akce.vyhledat-na-po'),
					}}
				/>
			</FormWidthElementLayout>
		</GovFormWeb>
	);
};
